export const BASE_URL_STRING = "https://api.pureeng.online/api/";

// export const BASE_URL_STRING = "https://localhost:7226/api/";
